import { render, staticRenderFns } from "./UserProfil.vue?vue&type=template&id=4d0a6e9e&scoped=true&"
import script from "./UserProfil.vue?vue&type=script&lang=js&"
export * from "./UserProfil.vue?vue&type=script&lang=js&"
import style0 from "./UserProfil.vue?vue&type=style&index=0&id=4d0a6e9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0a6e9e",
  null
  
)

export default component.exports